export default __webpack_public_path__ + "assets/howWork3.714c8ac2.png";